import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OverviewService {
  public startDate = signal(new Date(0));

  public endDate = signal(new Date());

  public _dateRange = computed(() => ({
    start: this.startDate(),
    end: this.endDate(),
  }));

  setStartDate(date: Date) {
    this.startDate.set(date);
  }

  setEndDate(date: Date) {
    this.endDate.set(date);
  }
}
